import React, { useState,useEffect } from 'react';
import Chart from "react-apexcharts";
import styled, { keyframes } from "styled-components";
import FeedbackTable from "./FeedbackTable";
import BenchmarkChart from "./components/BenchmarkChart";
import TrendChart from "./components/TrendChart";
import Timeline from "./components/Timeline";
import ROITable from "./ROITable";
import {calculate_average_outcome} from "../calculations";
import Likelihood from './Likelihoodv2';
import EffectPlot from './EffectPlot';
import Predictions from './Predictions';
import {Dropdown} from "semantic-ui-react";
import demo from './demo.json'



const math = require('mathjs');

const Model = ({data,core_data,selected,responses,outcomeStandards}) =>{
   const [min,setMin] = useState(0)
    const [max,setMax] = useState(0)
    const [modifiedData,setModifiedData] = useState()


    const [relativeImportance,setRelativeImportance] = useState([])
    const [series,setSeries] = useState(data3.series)
    const [options,setOptions] = useState(data3.options)
    const [loading,setLoading] = useState(true)
    const [feedback,setFeedback] = useState([])
    const [outcomeScore,setOutcomeScore] = useState(0)
    const [selectedNav, setSelectedNav] = useState(0)
    const [selectedModel, setSelectedModel] = useState('Culture')


    useEffect(()=>{
        setModifiedData(data)
    },[data])

    useEffect(()=>{
        setLoading(true)
        if(data && selectedModel=='EQ'){
            let _data = JSON.parse(JSON.stringify(data))
            _data.score = demo
            setModifiedData(_data)
            setRelativeImportance(calculate_relative_importance(_data))
        }
        
        if(data && selectedModel=='Culture'){
            setModifiedData(data)
            setRelativeImportance(calculate_relative_importance(data))
            
        }

        setTimeout(()=>{
            setLoading(false)
        },300)

    },[selectedModel,data])


    const get_all_feedback = () =>{
        if(relativeImportance.length> 0 && max>0){
            let feedback = []
            relativeImportance.slice(0,2).map(item=>{
                let importance = (item.value-min)/(max-min)*100

                    feedback.push(
                        {data:core_data.feedback?.filter(f=>f?.dimension == item.index?.dimension && f?.factor == item.index.factor),
                            name:item.name,
                        })
            })
            feedback.push({data:core_data.feedback?.filter(f=>f.type=='Outcome' && f.outcome == parseInt(data.outcome.id)),
                name:data.outcome.name
            })

            return feedback
        }

        return []
    }

    
    const calculate_relative_importance = (newData) =>{
        let _data = []
         Object.keys(newData.score.model).map((item,index)=>{
            let _item = newData.score.model[item]
            if(_item.importance > 0){
                _data.push( {
                    name:item,
                    index:_item.index,
                    value:Math.abs(_item.coefficient)
                })
            }
            
        })

        _data.sort((a,b)=>b.value-a.value)

        return _data.slice(0,6)

    }


    useEffect(()=>{
        if(relativeImportance.length> 0){
        setMin(math.min(relativeImportance.map(item=>item.value)))
        setMax(math.max(relativeImportance.map(item=>item.value)))
        }
    }
    ,[relativeImportance])

    useEffect(()=>{
        if(relativeImportance.length> 0){
            setLoading(true)
            let _options = {...options}
            setSeries(relativeImportance.map(item=>item.value))
            _options.labels = relativeImportance.map(item=>item.name)
            const total = relativeImportance.reduce((sum, item) => sum + item.value, 0);
            _options.tooltip= {
                y: {
                    formatter: (val, { series, seriesIndex }) => {
                        return `explains ${(val/total*100).toFixed(1)}% of the total predictive power of culture.`; // Displaying percentage and absolute value
                      }
                }
              }

            _options.colors = [
                '#27CDA7',  // Fully opaque red
                '#2D70E2',  // Semi-transparent blue
                'rgba(252, 220, 224, 0.6)',  // More transparent yellow
                'rgba(255, 237, 207, 0.6)',
                'rgba(213, 226, 249, 0.6)',  // Semi-transparent green
                 'rgba(213, 226, 249, 0.6)'
              ]
            setOptions(_options)
            setTimeout(()=>{
                setLoading(false)
            },300)

            setFeedback(get_all_feedback())
        }
    },[relativeImportance,min,max])


    const calculate_scores = () =>{
        return calculate_average_outcome(responses[0],selected)
    }

    useEffect(()=>{
        if (responses?.length > 0) {
          setOutcomeScore(calculate_average_outcome(responses[0], selected));
        }
    },[responses,data])

    const get_outcome_benchmark = () =>{
        console.log(outcomeStandards)
    }

    // const generate_content = () =>{
    //     switch(selectedNav){
    //         case 0:
    //             return <Predictions data={modifiedData} options={options} series={series} loading={loading}/>
    //         case 1:
    //             return <Likelihood data={data} />
    //         case 2:
    //             return <ROITable data={modifiedData} core_data={core_data} title={data?.outcome.name}/>
    //         case 3:
    //             return <BenchmarkChart score={outcomeScore}/>
    //         case 4:
    //             return <FeedbackTable 
    //             feedback={feedback} 
    //             name={data?.outcome.name} 
    //             importance={relativeImportance}
    //             selected={selected}/>

    //         case 5:
    //             return (<>
    //                 <TrendChart/>
    //                 <Timeline/>
    //             </>)

    //         case 6:
    //             return <EffectPlot data={data}/>
    //         default:
    //             return <div>1</div>
    //     }
    // }
    


    return (
        <Container>
            {/* <BenchmarkChart score={outcomeScore} title={data?.outcome.name} standards={outcomeStandards} selected={selected}/>
            <Predictions data={modifiedData} options={options} series={series} loading={loading} type={selectedModel}/> */}
            <ROITable data={modifiedData} core_data={core_data} title={data?.outcome.name} type={selectedModel}/>

        </Container>
    )

}

export default Model


const Container = styled.div`   
    width:calc(50% - 20px);
    position:relative;
`


const data3 = {
	series: [22,18,17,10],
	options: {
		chart: {
			type: "pie",
			fontFamily:"Poppins, sans-serif",
			foreColor: '#7E7E7E',
			width: 400,
		},
        legend: {
            show: true,
            position: 'bottom',
          }

        
	}
};
